jQuery(function ( $ ) {

  const $sliderContainer = $('.products-menu');

  // check if product menu exist
  if($sliderContainer.length > 0) {

    const $slider = $('.products-menu__list');
    const $sliderItems = $('.products-menu__list-single-link');

    // slick slider settings
    const settings = {
      speed: 500,
      infinite: false,
      arrows: true,
      prevArrow:"<div class='slick-prev-arrow'></div>",
      nextArrow:"<div class='slick-next-arrow'></div>",
      variableWidth: true,
      responsive: [
        {
          breakpoint: 99999,
          settings: "unslick"
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    }

    // initialize slick slider
    $slider.slick(settings);

    // show slider
    $sliderContainer.css({
      'zIndex': '9',
      'opacity': '1'
    });

    // setup scroll animation on click
    $sliderItems.each(function() {
      $(this).on("click", function(e) {
        e.preventDefault();
        // set variables
        let $windowWidth = $(window).width();
        let $target = $($(this)[0].hash);
        let scrollOffset = $windowWidth < 768 ? 70 : 90;
        // animate scroll
        $('html, body').animate({
          scrollTop: $target.offset().top - scrollOffset
        }, 500);
      });
    });


    // reslick only if it's not initialized
    $(window).on('resize', function() {
      if ($(window).width() > 1199) {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
        return
      }

      if (!$slider.hasClass('slick-initialized')) {
        return $slider.slick(settings);
      }
    });

  }
});


